/* PDLYTE concept themes, v2 behaviour: scroll reveal (progressive, respects reduced motion),
   gallery image crossfade, and nothing that changes prices or cart logic. */
(() => {
  'use strict';
  if (window.pdx2Loaded) return;
  window.pdx2Loaded = true;
  const root = document.documentElement;
  root.classList.add('pdx-js');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  const targets = [
    '.pdx-cards__grid > *', '.pdx-products__grid > *', '.pdx-review', '.pdx-inside__card', '.pdx-steps__list > li',
    '.pdx-reasons__list > li', '.pdx-benefit-strip > li', '.pdx-timeline__moment', '.pdx-guarantee__cells > li',
    '.pdx-stat', '.pdx-compare__row', '.pdx-editorial__copy', '.pdx-editorial__media', '.pdx-inside__media',
    '.pdx-reasons__media', '.pdx-story__leadcopy', '.pdx-faq__head', '.pdx-accordion--faq', '.pdx-collage > img'
  ].join(',');
  let io = null;
  const reveal = (scope) => {
    if (reduced || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    }
    const vh = window.innerHeight || 800;
    scope.querySelectorAll(targets).forEach((el) => {
      if (el.classList.contains('pdx-reveal') || el.classList.contains('is-in')) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) return; /* visible on load: never hide what is already on screen */
      const siblings = el.parentElement ? Array.from(el.parentElement.children) : [el];
      const index = Math.max(0, siblings.indexOf(el)) % 4;
      el.style.setProperty('--pdx-delay', (index * 70) + 'ms');
      el.classList.add('pdx-reveal');
      io.observe(el);
    });
  };

  /* ---------- Gallery crossfade ---------- */
  const galleryFade = (scope) => {
    scope.querySelectorAll('[data-pdx-gallery]').forEach((gal) => {
      if (gal.dataset.fade) return;
      gal.dataset.fade = '1';
      const img = gal.querySelector('[data-pdx-gallery-main] img');
      if (!img || reduced) return;
      gal.addEventListener('click', (e) => {
        if (!e.target.closest('[data-pdx-thumb],[data-pdx-gallery-prev],[data-pdx-gallery-next]')) return;
        img.style.opacity = '0.35';
        const done = () => { img.style.opacity = ''; img.removeEventListener('load', done); };
        img.addEventListener('load', done);
        setTimeout(done, 700);
      });
    });
  };

  const initialise = (scope = document) => { reveal(scope); galleryFade(scope); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (e) => initialise(e.target));
})();
